"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/image";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/i18n/routing";
import { ExternalLinkIcon } from "lucide-react";
import * as motion from "motion/react-client";
import { useTranslations } from "next-intl";
import { FC } from "react";
type ProjectProps = {
  name: string;
  title: string;
  href: string;
  types: ("web" | "mobile")[];
  image: string;
};
const Project: FC<ProjectProps> = t0 => {
  const $ = _c(33);
  const {
    name,
    title,
    href,
    types,
    image
  } = t0;
  const t = useTranslations("Home");
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      translateY: -6
    };
    t2 = {
      type: "spring",
      stiffness: 300,
      damping: 20
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== image || $[3] !== title) {
    t3 = <Image src={image} alt={title} width={480} height={320} className="h-full w-full object-cover object-top group-hover:scale-105 transition-transform duration-700 ease-out" />;
    $[2] = image;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="absolute inset-0 bg-linear-to-t from-card/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute top-3 right-3 size-8 rounded-lg bg-background/80 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 translate-y-1 group-hover:translate-y-0"><ExternalLinkIcon className="size-3.5 text-foreground" /></div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3) {
    t6 = <div className="h-48 overflow-hidden relative">{t3}{t4}{t5}</div>;
    $[7] = t3;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== title) {
    t7 = <h4 className="font-semibold text-foreground text-base">{title}</h4>;
    $[9] = title;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = `sections.projects.apps.${name}.description` as any;
  let t9;
  if ($[11] !== t || $[12] !== t8) {
    t9 = t(t8);
    $[11] = t;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t9) {
    t10 = <p className="text-sm text-muted-foreground leading-relaxed flex-1">{t9}</p>;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== types) {
    t11 = types.includes("web") && <Badge variant="secondary" className="text-[11px] px-2.5 py-0.5 font-medium">Web</Badge>;
    $[16] = types;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== types) {
    t12 = types.includes("mobile") && <Badge variant="secondary" className="text-[11px] px-2.5 py-0.5 font-medium bg-[hsl(var(--accent))]/10 text-[hsl(var(--accent))] border-[hsl(var(--accent))]/20">Mobile</Badge>;
    $[18] = types;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t12) {
    t13 = <div className="flex items-center gap-2 mt-1">{t11}{t12}</div>;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t10 || $[24] !== t13 || $[25] !== t7) {
    t14 = <div className="flex flex-col flex-1 gap-3 p-5">{t7}{t10}{t13}</div>;
    $[23] = t10;
    $[24] = t13;
    $[25] = t7;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t14 || $[28] !== t6) {
    t15 = <motion.div whileHover={t1} transition={t2} className="flex flex-col h-full bg-card border border-border rounded-xl overflow-hidden transition-all duration-300 hover:border-[hsl(var(--accent))]/25 hover:glow-accent">{t6}{t14}</motion.div>;
    $[27] = t14;
    $[28] = t6;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== href || $[31] !== t15) {
    t16 = <Link href={href} target="_blank" className="group">{t15}</Link>;
    $[30] = href;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
};
export default Project;